import './GetStarted.scss';

import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@myome/ui';

import ArrowBullet from '@components/ArrowBullet/arrowBullet';
import TextImage from '@components/TextImage/TextImage';
import { RESOURCES_URL } from '@constants/constants';

interface GetStartedProps {
  onStart: () => void;
  showResources?: boolean;
}

export const GetStarted = ({ onStart, showResources = true }: GetStartedProps) => {
  return (
    <section className='get-started'>
      <TextImage
        desktopBackgroundImageSrc='/img/block-backgrounds/blue-white-dots-background.webp'
        mobileBackgroundImageSrc='/img/block-backgrounds/dark-blue-white-dots-mobile.webp'
        mobileLayout='text-image'
        desktopLayout='text-image'
        alt='Ready to get started'
        buttons={
          <div className='get-started__buttons'>
            <Button onClick={onStart} variant='tertiary' endIcon={<FontAwesomeIcon icon={faArrowRight} />}>
              Sign Up Here
            </Button>
            {showResources && (
              <a href={RESOURCES_URL} target='_blank' rel='noreferrer' className='access-resources-link'>
                <ArrowBullet />
                Access Resources
              </a>
            )}
          </div>
        }
      >
        <h2>Ready to Get Started?</h2>
      </TextImage>
    </section>
  );
};
